export enum MembershipType {
  GENERAL = "GENERAL",
  PILOT = "PILOT",
  SELF_SERVICE = "SELF_SERVICE"
}
